import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RespetaIvaComponent } from './respeta-iva.component';



@NgModule({
  declarations: [
    RespetaIvaComponent
  ],
  imports: [
    CommonModule
  ], exports: [
    RespetaIvaComponent
  ]
})
export class RespetaIvaModule { }
